import { Icon, IconProps } from "@chakra-ui/react";
import { EmrBed, EmrVitals, EmrNurse } from "@medstonetech/slate-icons";

import * as React from "react";
import { ChartType } from "types";

function getChartTypeIcon(chartType: ChartType, props: IconProps) {
  switch (chartType) {
    case "Chart":
      return <Icon as={EmrVitals} {...props} />;
    case "Triage":
      return <Icon as={EmrNurse} {...props} />;
    case "Observation":
      return <Icon as={EmrBed} {...props} />;
    default:
      return <Icon as={EmrNurse} {...props} />;
  }
}

export { getChartTypeIcon };
